if (!customElements.get('pet-customer-reviews')) {
  customElements.define(
    'pet-customer-reviews',
    class PetCustomerReviews extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-show-reviews]');
        if (!this.button) return;

        this.button.addEventListener('click', () => {
          this.querySelectorAll('[data-review-card][hidden]').forEach((card) => card.removeAttribute('hidden'));
          this.button.hidden = true;
        });

        document.addEventListener('shopify:block:select', (event) => {
          if (this.contains(event.target)) event.target.removeAttribute('hidden');
        });
      }
    }
  );
}
